module.exports = __webpack_public_path__ + "static/media/mod_tacan_turbos.8977b07f.glb";